
import { routes_names, layout_names } from '../constants'
// layouts
import AuthLayout from '@/layouts/Auth.vue'
import DashboardLayout from '@/layouts/Dashboard.vue'

export const routes = [
  {
    path: '/',
    name: layout_names.authorization,
    component: AuthLayout,
    redirect: {
      name: routes_names.login
    },
    children: [
      {
        path: '/login',
        name: routes_names.login,
        component: () => import('@/views/auth/Login.vue'),
        meta: {
          title: 'Login',
        },
      }
    ],
    meta: {
      notRequiresAuth: true,
    },
  },
  {
    path: '/',
    name: layout_names.dashboard,
    component: DashboardLayout,
    redirect: {
      name: routes_names.main
    },
    children: [
      {
        path: '/dashboard',
        name: routes_names.main,
        component: () => import('@/views/app/index.vue'),
        meta: {
          title: 'Dashboard',
        },
      },
      {
        path: '/prompts',
        name: routes_names.prompts,
        component: () => import('@/views/app/Prompts.vue'),
        meta: {
          title: 'Prompts',
        },
      },
      {
        path: '/plans',
        name: routes_names.plans,
        component: () => import('@/views/app/Plans.vue'),
        meta: {
          title: 'Plans',
        },
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
]